var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 53,
    cy: 53,
    r: 53
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E4E4E4",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.876 75.62 62.75 68.98c-.582 4.645-4.542 7.382-9.343 7.382-4.778 0-8.723-2.701-9.335-7.312l-16.948 6.57c-3.026 1.246-7.078 5.165-7.078 10.98v21.153a2.359 2.359 0 0 0 2.358 2.359h62.193a2.359 2.359 0 0 0 2.359-2.359V86.6c0-5.815-4.052-9.734-7.079-10.98z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.418 107.753V83.336c0-4.513 2.44-7.883 4.948-9.748l-5.243 2.033c-3.026 1.245-7.078 5.164-7.078 10.979v21.153a2.359 2.359 0 0 0 2.358 2.359h7.374a2.359 2.359 0 0 1-2.36-2.359z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.07 69.05c.613 4.61 4.558 7.312 9.335 7.312 4.802 0 8.762-2.737 9.344-7.381l-.715-.278c-.381-.147-1.274-.389-1.274-1.39v-4.625l-.041.025v-.108a12.831 12.831 0 0 1-7.127 2.153c-2.829 0-5.316-.774-7.353-2.07v4.625c0 1.001-.893 1.243-1.274 1.39-.073.03-.393.153-.894.347z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.44 75.988h2.965V64.755c-2.751-.033-5.174-.8-7.166-2.067v4.625c0 1.002-.893 1.243-1.274 1.39-.073.03-.393.153-.894.347.48 3.61 3.002 6.05 6.368 6.938z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.031 42.398c-.425.35-.969.56-1.56.56-.333 0-1.393-.62-1.707-.687l.735 9.943c0 .123-.006.245-.01.367 3.178.18 6.076-2.17 6.076-5.023 0-2.216-1.435-4.467-3.534-5.16z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.43 43.157c-.42-.33-.889-.59-1.399-.759-.425.35-.969.56-1.56.56-.333 0-1.393-.62-1.707-.687l.735 9.943c0 .123-.005.245-.009.367a6.169 6.169 0 0 0 3.94-1.154v-8.27z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.312 52.214.973-9.619-2.586.363c-.49 0-.958-.096-1.389-.264-1.742.85-3.064 2.851-3.064 4.864 0 2.85 2.893 5.204 6.075 5.023-.004-.122-.01-.244-.01-.367z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.368 51.657c-1.546-.945-2.602-2.513-2.602-4.262 0-1.835 1.064-3.658 2.55-4.664l-1.618.227c-.49 0-.957-.096-1.388-.264-1.742.85-3.064 2.851-3.064 4.864 0 2.85 2.893 5.204 6.074 5.023-.003-.122-.009-.244-.009-.367l.057-.557z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B9B9B9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.37 76.024a.917.917 0 0 1-.288-.787h-5.165a.917.917 0 0 1-.289.787l-.26.24v8.914c0 .725.587 1.312 1.311 1.312h3.64c.725 0 1.313-.588 1.313-1.312v-8.914l-.261-.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.833 71.08 7.237 7.881a.92.92 0 0 0 1.3.056l3.258-2.993a.92.92 0 0 0 .056-1.3l-5.577-6.073-.142.052-6.132 2.378zM68.166 71.08l-7.236 7.881a.92.92 0 0 1-1.3.056l-3.26-2.993a.92.92 0 0 1-.055-1.3l5.578-6.073c.051.019.1.036.14.052l6.133 2.378z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.765 37.888c0-.252-.338-.34-.457-.117a9.11 9.11 0 0 1-8.04 4.824H40.311v9.619c0 6.746 5.285 12.907 13.28 12.907 7.117 0 12.907-5.79 12.907-12.907v-9.721c-2.126-.452-3.734-2.35-3.734-4.605z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.026 52.214v-9.619H40.31v9.619c0 6.746 5.286 12.907 13.281 12.907 1.478 0 2.898-.253 4.222-.713-5.421-1.805-8.788-6.812-8.788-12.194z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.66 25.968c-1.232.094-2.364-.681-2.601-1.895-.4-2.044-1.412-4.073-5.366-4.073H43.976a9.115 9.115 0 0 0-9.116 9.115V39.12a3.838 3.838 0 0 0 3.838 3.838h15.569a9.11 9.11 0 0 0 8.04-4.823c.12-.223.457-.136.457.116a4.721 4.721 0 0 0 4.708 4.707 2.475 2.475 0 0 0 2.467-2.467V30.05c0-2.459-2.145-4.246-4.278-4.082z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.07 39.12V29.114A9.115 9.115 0 0 1 53.187 20h-9.21a9.115 9.115 0 0 0-9.116 9.115V39.12a3.838 3.838 0 0 0 3.839 3.838h9.21a3.838 3.838 0 0 1-3.838-3.838z",
    fill: "#A4A4A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberCircle);
export default __webpack_public_path__ + "static/media/member-circle.1cb86277c9cb4452745473ba6fa72e48.svg";
export { ForwardRef as ReactComponent };